<template>
  <highcharts :options="chartOptions" :ref="chart_id"></highcharts>
</template>

<script>
import { Chart } from "highcharts-vue";
import moment from "moment";
import Highcharts from "highcharts/highcharts.js";
export default {
  name: "pie_chart",
  props: {
    data: Array,
    chart_id: {
      type: String,
      default: "pie-chart",
    },
    config: {
      type: Object,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      dataset: this.data,
      chartOptions: {},
    };
  },
  methods: {
    loadPie: function () {
      let self = this;
      this.chartOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: this.height != null ? this.height : 300,
          type: "pie",
          backgroundColor: "transparent",
        },
        title: {
          text: null,
        },
        colors: [
        "#4572A7", "#28a745", "#343a3f", "#ffc007", "#dc3444"
        ],
        credits: {
          enabled: false,
        },
        tooltip: {
          // pointFormat:
          //   "{series.name}: <b>{point.y} ({point.percentage:.1f}%)</b>",
          formatter: function () {
            var s = '<b>' + this.series.name + '</b> :'
              + Highcharts.numberFormat(this.point.y, 0, ',', ',')
            // + ' (' + Math.round(this.point.percentage) + '%)';
            return s;
          }
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        legend:
          this.config != null
            ? this.config
            : {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              maxHeight: 100,
            },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              style: {
                textOutline: false
              },
              format: "<b>{point.y}</b>",
            },
            showInLegend: true,
          },
        },
        exporting: {
          enabled: true,
        },
        series: [
          {
            name: this.dataset.name ? this.dataset.name : "Total",
            source: this.dataset.source ? this.dataset.source : null,
            account: this.dataset.account ? this.dataset.account : null,
            topic_selected: this.dataset.topic_selected ? this.dataset.topic_selected : null,
            query: this.dataset.query ? this.dataset.query : null,
            colorByPoint: true,
            data: this.dataset,
            point: {
              events: {
                click: function () {
                  let start = "";
                  let end = "";
                  let params = {};

                  start = moment(self.$route.query.from).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  end = moment(self.$route.query.to).format(
                    "YYYY-MM-DD HH:mm:ss"
                  );
                  let sentimen;
                  if (this.name == "Positif") {
                    sentimen = btoa(1);
                  } else if (this.name == "Netral") {
                    sentimen = btoa(0);
                  } else if (this.name == "Negatif") {
                    sentimen = btoa(-1);
                  }
                  params = {
                    from: start,
                    to: end,
                    sentiments: sentimen,
                  };

                  if ("topic_selected" in self.$route.query) {
                    params.topic_selected = self.$route.query.topic_selected;
                  }
                  if ("cakupan" in self.$route.query) {
                    params.cakupan = self.$route.query.cakupan;
                  }

                  if (this.source) {
                    params.sources = btoa(this.source);
                  }

                  if (this.account) {
                    params.account = this.account;
                  }

                  if (this.query) {
                    params.q = this.query;
                  }

                  if (this.topic_selected) {
                    params.topic_selected = btoa(this.topic_selected);
                  }

                  self.$router.push({ path: "/posts", query: params });
                },
              },
            },
          },
        ],
      };
    },
  },
  mounted: function () {
    if (this.dataset != null) {
      this.loadPie();
    }
  },
};
</script>